// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-click-to-expand.minimized{cursor:pointer}.header-click-to-expand.expanded{cursor:default}", ""]);
// Exports
module.exports = exports;
